import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';

@NgModule({
  providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())],
})
export class SharedDataAccessModule {}
